export default __webpack_public_path__ + "static/media/student-profile.f5bc0ff0.svg";